import { httpService, HttpTask } from '@core/http';
import { Dashboard } from '@modules/iot/dashboard/model';
import { Threshold } from '@modules/iot/model';

export namespace DashboardService {
  import Level = Threshold.Level;
  const URI = '/iot/dashboard';
  export function getDashboard(includeMap: boolean, alertLevel: Level | null): HttpTask<Dashboard> {
    return httpService.get(URI, { params: { includeMap, alertLevel } });
  }

  export function getAlertSensors(level: Level | null): HttpTask<Array<Dashboard.AlertSensorsZone>> {
    return httpService.get(`${URI}/alerts/sensors`, { params: { level } });
  }
}
